<template>
	<div class="import-csv-block">
		<div class="d-flex">
			<div v-if="selectingStep < selectingSteps.length && !encodingSelected" class="small-block">
				<label class="select-label">Encoding</label>
				<div class="select-holder">
					<span>{{ CSVTasksFormat }}</span>
				</div>
			</div>
			<div v-if="selectingStep < selectingSteps.length && !encodingSelected" class="small-block">
				<label class="select-label">Separator</label>
				<div class="select-holder">
					<VSelect 
						:options="separatorOptions"
						value="id"
						title="title"
						:setDefaultValue="separator"
						@selectHandler="saveSeparator"
						:key="separator"
					/>
					<i class="icon-arrow-down-small"></i>
				</div>
			</div>
		</div>
		<div v-if="selectingStep < selectingSteps.length && !encodingSelected" class="text-right">
			<VButton active @clickHandler="() => encodingSelected = true">Next</VButton>
		</div>
		<span
			v-if="selectingStep < selectingSteps.length && encodingSelected"
			class="step-desc"
		>{{ selectingSteps[selectingStep].title }}</span>
		<div v-if="selectingStep < selectingSteps.length && encodingSelected" class="table-holder">
			<table class="table" ref="import-table">
				<tbody>
					<tr
						v-for="(row, row_index) in formatedCSVTasks"
						:key="row_index"
					>
						<td
							v-for="(col, col_index) in row"
							:key="col_index"
							@mouseover="hoverSelect(col_index, row_index)"
							@click="selectData(col_index, row_index)"
						>
							{{ col }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div v-else-if="filteredTasks.length > 0">
			<div class="table-holder">
				<table class="table" ref="imported-table">
					<thead>
						<tr>
							<th>Title</th>
							<th>Body</th>
							<th>Assignee</th>
							<th>List</th>
							<th>Created</th>
							<th>Minutes</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(task, task_index) in filteredTasks"
							:key="task_index"
						>
							<td>{{ task.title }}</td>
							<td>{{ task.body }}</td>
							<td>
								<div class="cell-holder">
									<span v-if="!task.assignee?.id">{{ task.assignee }}</span>
									<div class="select-holder">
										<VSelect 
											:options="activeBoard.members"
											value="id"
											title="username"
											:setDefaultValue="task.assignee?.id"
                                            @selectHandler="(val) => saveSelect(val, activeBoard.members, 'assignee', task)"
										/>
										<i class="icon-arrow-down-small"></i>
									</div>
								</div>
							</td>
							<td>
								<div class="cell-holder">
									<span v-if="!task.list_name?.id">{{ task.list_name }}</span>
									<div class="select-holder">
										<VSelect 
											:options="activeBoardTasks"
											value="id"
											title="title"
											:setDefaultValue="task.list_name?.id"
											@selectHandler="(val) => saveSelect(val, activeBoardTasks, 'list_name', task)"
										/>
										<i class="icon-arrow-down-small"></i>
									</div>
								</div>
							</td>
							<td>{{ task.date }}</td>
							<td>{{ task.minutes }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="text-right">
				<VButton active @clickHandler="tasksUpload">Add to the project</VButton>
			</div>
		</div>
		<div v-if="encodingSelected" class="pt-1">
			<VButton @clickHandler="goBack">Back</VButton>
		</div>
		<Flash ref="show"/>
	</div>
</template>

<script>
import jschardet from 'jschardet'
import { api } from "@/mixins/axios";
import VSelect from "@/components/atoms/VSelect.vue";
import VButton from "@/components/atoms/VButton";
import Flash from "@/components/Flash.vue";

export default {
	name: 'ImportCSV',
	components: {
		VSelect,
		VButton,
		Flash
	},
	data() {
		return {
			separator: ',',
			separatorOptions: [
				{id: ',', title: ','},
				{id: '|', title: '|'},
				{id: ';', title: ';'}
			],
			dataIndex: null,
			taskTitle: null,
			taskBody: null,
			members: null,
			listTitle: null,
			createdDate: null,
			minutes: null,
			encodingSelected: false,
			selectingStep: 0,
			selectingSteps: [{
				title: 'Please select the first data row (without the titles)',
				selecting: 'dataIndex',
				hover: 'row'
			}, {
				title: 'What is the task title?',
				selecting: 'taskTitle',
				hover: 'col'
			}, {
				title: 'What is the task body?',
				selecting: 'taskBody',
				hover: 'col'
			}, {
				title: 'What is the members?',
				selecting: 'members',
				hover: 'col'
			}, {
				title: 'What is the list title?',
				selecting: 'listTitle',
				hover: 'col'
			}, {
				title: 'What is the registered time?',
				selecting: 'minutes',
				hover: 'col'
			}, {
				title: 'What is the created date?',
				selecting: 'createdDate',
				hover: 'col'
			}],
			filteredTasks: []
		}
	},
	methods: {
		saveSeparator(val) {
			this.separator = val
		},
		selectData(col_index, row_index) {
			if(this.selectingSteps[this.selectingStep].hover == 'col') {
				this[this.selectingSteps[this.selectingStep].selecting] = col_index
			}
			if(this.selectingSteps[this.selectingStep].hover == 'row') {
				this[this.selectingSteps[this.selectingStep].selecting] = row_index
			}

			this.selectingStep++
			if(this.selectingStep >= this.selectingSteps.length) {
				this.$refs['import-table'].querySelectorAll('td').forEach((col, index, list) => {
					list[index].classList.remove('hover-col')
					list[index].classList.remove('hover-row')
				})

				this.filteredTasks = []
				this.formatedCSVTasks.slice(this.dataIndex).forEach(row => {
					let assignee = this.activeBoard.members.find(member => {
						return member.username.toLowerCase().indexOf(row[this.members].toLowerCase()) >= 0 
						|| member.name.toLowerCase().indexOf(row[this.members].toLowerCase()) >= 0
					})
					let list_name = this.activeBoardTasks.find(list => {
						return list.title.toLowerCase().indexOf(row[this.listTitle].toLowerCase()) >= 0
					})
					
					let taskObj = {
						title: row[this.taskTitle],
						body: row[this.taskBody],
						assignee: assignee || row[this.members],
						list_name: list_name || row[this.listTitle],
						date: row[this.createdDate],
						minutes: row[this.minutes]
					}
					this.filteredTasks.push(taskObj)
				})
				
				return 
			}
		},
		hoverSelect(col_index, row_index) {
			if(this.selectingSteps[this.selectingStep].hover == 'col') {
				this.$refs['import-table'].querySelectorAll('tr').forEach((row, index, list) => {
					list[index].querySelectorAll('td').forEach((col, i, arr) => {
						arr[i].classList.remove('hover-col')
						arr[i].classList.remove('hover-row')

						if(i == col_index) {
							arr[i].classList.add('hover-col')
						}
					})
				})
			}
			if(this.selectingSteps[this.selectingStep].hover == 'row') {
				this.$refs['import-table'].querySelectorAll('tr').forEach((row, index, list) => {
					list[index].querySelectorAll('td').forEach((col, i, arr) => {
						arr[i].classList.remove('hover-col')
						arr[i].classList.remove('hover-row')
					})

					if(index == row_index) {
						list[index].querySelectorAll('td').forEach((col, i, arr) => (arr[i].classList.add('hover-row')))
					}
				})
			}
		},
		delimiterDetect(csvText) {
			let txt = csvText.split("\n")[0];
			let delimiterData = [
				{sign: ',', splitted: 0},
				{sign: ';', splitted: 0},
				{sign: '|', splitted: 0}
			]
			delimiterData.forEach((item, index) => {
				item['splitted'] = txt.split(item['sign']).length
			})
			let maxFound = delimiterData.reduce((prev, current) => {
				return (prev && prev.splitted > current.splitted) ? prev : current
			})
			return maxFound.sign
		},
		formatDate(date) {
			let newDate = new Date(date)
			return `${newDate.getFullYear()}-${('0' + (newDate.getMonth()+1)).slice(-2)}-${('0' + newDate.getDate()).slice(-2)}`
		},
		async tasksUpload() {
			const data = {
                project_id: this.activeBoard.id,
                tasks: this.filteredTasks.map(task => {
					return {
						title: task.title,
						body: task.body,
						assignee: task.assignee?.username || task.assignee,
						list_name: task.list_name?.title || task.list_name,
						date: this.formatDate(task.date),
						minutes: Number(task.minutes)
					}
				})
            }
            try {
                const response = await api.post('/task_bulk_upload', data)

				if (response.data.msg == 'ok') {
                	this.$refs.show.showFlashSuccess('Successfully added')
					setTimeout(() => {
						this.$store.dispatch('setImportCSV', null)
					}, 2000);
                }
            } catch (e) {
				console.log(e)
                this.$refs.show.showFlashError(e.response?.data?.msg || 'Something went wrong!')
            }
		},
		saveSelect(val, list, prop, task) {
			task[prop] = list.find(item => item.id == val)
		},
		csvToJson(text) {
			let quoteChar = '"';
			let delimiter = ',';
			const regex = new RegExp(`\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`, 'gs');
			
			const headings = text.substring(0, text.indexOf('\n')).split(delimiter)
			const content = text.substring(text.indexOf('\n') + 1)

			const match = line => [...line.matchAll(regex)]
				.map(m => m[2])
				.slice(0, -1);

			const lines = content.split(/\n\r/);

			return [headings, ...lines.map(line => match(line))];
		},
		goBack() {
			if(this.selectingStep == 0) {
				this.encodingSelected = false
			} else {
				this.selectingStep--
			}
		}
	},
	mounted() {
		this.separator = this.delimiterDetect(this.importCSVTasks)
	},
	computed: {
        importCSVTasks() {
            return this.$store.getters.importCSVTasks
        },
		CSVTasksFormat() {
            return jschardet.detect(this.importCSVTasks.toString()).encoding
		},
		formatedCSVTasks() {
			return this.importCSVTasks.split('\r\n')
			.map(item => item.split(this.separator).filter(item => item))
			.filter(item => item.length > 0)
		},
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        activeBoardTasks() {
            return this.$store.getters.activeBoardTasks
        },
	}
}
</script>

<style lang="scss">
.import-csv-block {
	.table-holder {
		border: 0.5px solid var(--outline);
		border-radius: 10px;
		overflow-x: auto;
		padding: 10px;
		margin-bottom: 20px;
	}

	.table {
		width: 100%;
		white-space: nowrap;
		font-size: 14px;

		tr {
			&:first-child {
				td.hover-col {
					&:before {
						border-radius: 7px 7px 0 0;
					}
				}
			}

			&:last-child {
				td.hover-col {
					&:before {
						border-radius: 0 0 7px 7px;
					}
				}
			}
		}

		td {
			padding: 7px 10px;
			border-right: 0.5px solid var(--outline);
			position: relative;

			&.hover-row,
			&.hover-col {
				cursor: pointer;

				&:before {
					background-color: $blue-1;
				}
			}
			
			&.hover-row {
				&:first-child {
					&:before {
						border-radius: 7px 0 0 7px;
					}
				}

				&:last-child {
					&:before {
						border-radius: 0 7px 7px 0;
					}
				}
			}

			&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background-color: transparent;
				z-index: -1;
			}

			&:last-child {
				border-right: none;
			}
		}

		.select-holder {
			margin-bottom: 0;
		}
	}

	.select-holder {
        position: relative;
		margin-bottom: 17px;

        & > i {
            font-size: 6px;
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
        }

        .custom-select {
            border-radius: 10px;
            border-color: var(--outline);
			font-size: 14px;
        }

		.select-selected {
			padding: 3px 20px 3px 10px;
		}
    }

    .select-label {
        display: block;
        margin-bottom: 5px;
    }

	.small-block {
		max-width: 100px;
		margin-right: 15px;
	}

	.cell-holder {
		display: flex;
		align-items: center;
		gap: 7px;
	}

	.pt-1 {
		padding-top: 10px;
	}
}
</style>